import { Icon, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './actSetupSubActionHeader.module.scss'
import { Button } from 'src/design_system/molecules/button/Button'

type ActSetupSubActionHeaderProps = {
  children?: React.ReactNode
  title: string
  isFixedHeader?: boolean
  onBack: () => void
}

const ActSetupSubActionHeader: React.FC<
  ActSetupSubActionHeaderProps
> = props => {
  const { title, isFixedHeader, onBack, children } = props

  return (
    <div
      className={`${styles.header} ${isFixedHeader ? styles.fixedHeader : ''}`}
    >
      <Button
        padding="2px 12px 2px 6px"
        borderRadius="0.75rem"
        fill="#333"
        boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.08)"
        onClick={onBack}
        gap={'x0'}
      >
        <Icon name="leftChevron" size="xSmall" primaryColor="#efefef" />
        <Text
          type="body"
          content="Back"
          style={{
            fontSize: '0.75rem',
            fontWeight: 500,
            color: '#efefef',
          }}
        />
      </Button>
      <Text
        type="body"
        content={title}
        weight="extraBold"
        style={{
          fontSize: '18px',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'pre',
          padding: '0 0.5rem',
        }}
      />
      {children}
    </div>
  )
}

export default ActSetupSubActionHeader
